<template>
  <div>
    <div class="main-layout__list main-layout__list_mxh80">
      <div
        class="main-layout__item main-layout__item_hover main-layout__item_head main-layout__item_p12"
      >
        <div class="w-3 t-c foz-23">
          <p>#</p>
        </div>

        <div class="w-10">
          <span>{{ $t("controls.work") }}</span>
        </div>

        <div class="w-14">
          <p>{{ $t("controls.skills") }}</p>
        </div>

        <div class="w-14">
          <p>{{ $t("controls.tools") }}</p>
        </div>

        <div class="w-10">
          <p>{{ $t("listsHeader.canUseScooter") }}</p>
        </div>

        <div class="main-layout__item-actions">
          <p>{{ $t("listsHeader.actions") }}</p>
        </div>
      </div>

      <div
        class="main-layout__item main-layout__item_hover main-layout__item_mh"
        v-for="(item, index) in list"
        :key="item.id"
        :class="{
          delete: item.deletion_tag,
        }"
      >
        <div class="w-3 t-c">
          <p>{{ index + 1 }}</p>
        </div>

        <div class="w-10">
          <span>{{ item.name }}</span>
        </div>

        <div class="w-14">
          <div v-for="(skill, index) in item.skills" :key="skill.id">
            <p
              :class="{
                'mb-6': index + 1 !== item.skills.length,
              }"
            >
              {{ skill.name }}
            </p>
          </div>
        </div>

        <div class="w-14">
          <div v-for="(tool, index) in item.instruments" :key="tool.id">
            <p
              :class="{
                'mb-6': index + 1 !== item.instruments.length,
              }"
            >
              {{ tool.name }}
            </p>
          </div>
        </div>

        <div class="w-10">
          <p v-if="item.can_use_scooter">+</p>
          <p v-else>-</p>
        </div>

        <div class="main-layout__item-actions">
          <div>
            <svg
              v-if="$guard('write', 'Tags')"
              @click="editTag(item)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div>
            <svg
              @click="openDeleteModal(item.id)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>

          <div>
            <delete-request
              v-if="$guard('delete', 'Tags') && item.deletion_tag"
              :item="item"
              :type="'work_tags'"
              @save="fetch"
              @remove="openDeleteModal"
            />
          </div>
        </div>
      </div>
    </div>

    <add-btn v-if="$guard('write', 'Tags')" @onClick="openModalAdapter" />

    <modal :show="isShow" :dark="true" :outside="false" @close="closeModal">
      <tags-modal :isUpdate="updatedId" @close="closeModal" @done="saveTag" />
    </modal>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure')"
        @cancel="closeDeleteModal"
        @next="deleteConfirm"
      />
    </modal>
  </div>
</template>

<script>
import addBtn from '@/components/controls/addBtn'
import tagsModal from '@/components/modals/tags/tagsModal'
import deleteRequest from '@/components/controls/deleteRequest'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    components: {
        addBtn,
        tagsModal,
        deleteRequest,
    },
    data() {
        return {
            isShow: false,
            isShowDeleteModal: false,
            isAdding: true,
            updatedId: null,
            deletedId: null,
        }
    },
    computed: {
        ...mapGetters({
            list: 'tags/list',
        }),
    },
    methods: {
        ...mapActions({
            requestForDelete: 'deleteControl/requestForDelete',
            fetch: 'tags/fetch',
            add: 'tags/add',
            update: 'tags/update',
            remove: 'tags/remove',
        }),
        ...mapMutations({
            setState: 'tags/setState',
        }),
        closeModal() {
            this.isShow = false
            this.updatedId = null
        },
        openModalAdapter() {
            this.isAdding = true
            this.openModal()
        },
        openModal() {
            this.isShow = true
        },
        closeDeleteModal() {
            this.isShowDeleteModal = false
        },
        openDeleteModal(id) {
            this.deletedId = id
            this.isShowDeleteModal = true
        },
        async deleteConfirm() {
            try {
                if (!this.$guard('delete', 'Tags')) {
                    await this.requestForDelete({
                        id: this.deletedId,
                        type: 'work_tags',
                    })
                    await this.fetch()

                    this.closeDeleteModal()
                    return
                }

                const response = await this.remove(this.deletedId)
                const isOkey = response.status === 200

                if (!isOkey) return
                await this.fetch()
                this.closeDeleteModal()
            } catch {
                // error
            }
        },
        async saveTag() {
            if (this.isAdding) {
                const response = await this.add()
                const isOkey = response.status === 201

                if (!isOkey) return
                await this.fetch()
                this.closeModal()
            } else {
                const response = await this.update(this.updatedId)
                const isOkey = response.status === 200

                if (!isOkey) return
                await this.fetch()
                this.closeModal()
            }
        },
        editTag(item) {
            this.isAdding = false
            this.setState({
                key: 'tag',
                data: {
                    name: item.name,
                    skills: item.skills,
                    instruments: item.instruments,
                },
            })
            this.updatedId = item.id
            this.openModal()
        },
    },
}
</script>
